var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97656 4.02344L14.1797 12.1875C14.3359 12.3828 14.3359 12.6562 14.1797 12.8516L5.97656 21.0156C5.82031 21.2109 5.50781 21.2109 5.3125 21.0156L4.53125 20.2734C4.375 20.0781 4.375 19.7656 4.53125 19.6094L11.6016 12.5L4.53125 5.42969C4.375 5.27344 4.375 4.96094 4.53125 4.76562L5.3125 4.02344C5.50781 3.82812 5.82031 3.82812 5.97656 4.02344ZM11.5625 4.02344C11.7578 3.82812 12.0703 3.82812 12.2266 4.02344L20.4297 12.1875C20.5859 12.3828 20.5859 12.6562 20.4297 12.8516L12.2266 21.0156C12.0703 21.2109 11.7578 21.2109 11.5625 21.0156L10.7812 20.2734C10.625 20.0781 10.625 19.7656 10.7812 19.6094L17.8516 12.5L10.7812 5.42969C10.625 5.27344 10.625 4.96094 10.7812 4.76562L11.5625 4.02344Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f0451077082d2eb8461015da023dad4e.svg";
export { ForwardRef as ReactComponent };